import { render } from "./WarehousePage.vue?vue&type=template&id=480a7129&scoped=true"
import script from "./WarehousePage.vue?vue&type=script&lang=js"
export * from "./WarehousePage.vue?vue&type=script&lang=js"

import "./WarehousePage.vue?vue&type=style&index=0&id=480a7129&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-480a7129"]])

export default __exports__